module.exports = __webpack_public_path__ + "img/top11.8efb0261.jpg";